module.exports = __webpack_public_path__ + "static/media/close-status.e96f4444.svg";